import { notification } from "antd";
import log from "./log";

export const showErrMsg = (error) => {
  let message = error.response ? error.response.data : error.message;
  log.error(message);
  notification.error({ description: message });
};
